import { SvgIcon } from '@mui/material';

const styles = {
  width: '53px!important',
  height: '40px!important',
  borderRadius: '8px',
};

export const NoImageIcon = () => {
  return (
    <SvgIcon width="53" height="40" viewBox="0 0 53 40" fill="none" sx={styles}>
      <rect width="53" height="40" rx="2" fill="#F9FAFB" />
      <path
        d="M29.2402 16H24.7598C20.4742 16 17 19.3579 17 23.5C17 27.6421 20.4742 31 24.7598 31H29.2402C33.5258 31 37 27.6421 37 23.5C37 19.3579 33.5258 16 29.2402 16Z"
        fill="#CBD2DC"
      />
      <path
        d="M32.3167 11H36C36 13.7614 34.0593 16 31.6654 16H28C28 13.2467 29.9297 11.0114 32.3167 11Z"
        fill="#E0E5EB"
      />
      <path
        d="M22 11.7608C24.3412 11.7608 26.2392 13.6588 26.2392 16H28C28 12.6863 25.3137 10 22 10V11.7608Z"
        fill="#A3B0C2"
      />
    </SvgIcon>
  );
};
